import { render, staticRenderFns } from "./WorkPermits.vue?vue&type=template&id=3ac6a090&scoped=true&"
import script from "./WorkPermits.vue?vue&type=script&lang=js&"
export * from "./WorkPermits.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermits.vue?vue&type=style&index=0&id=3ac6a090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6a090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac6a090')) {
      api.createRecord('3ac6a090', component.options)
    } else {
      api.reload('3ac6a090', component.options)
    }
    module.hot.accept("./WorkPermits.vue?vue&type=template&id=3ac6a090&scoped=true&", function () {
      api.rerender('3ac6a090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/dashboards/WorkPermits.vue"
export default component.exports